export default __webpack_public_path__ + "static/media/rental.3839b381.jpg";